const I18N = {
  en: {
    gapDesktopError: 'gcds-grid: Invalid spacing value for gap-desktop.',
    gapTabletError: 'gcds-grid: Invalid spacing value for gap-tablet.',
  },
  fr: {
    gapDesktopError: "gcds-grid: Valeur d'espacement invalide pour gap-desktop.",
    gapTabletError: "gcds-grid: Valeur d'espacement invalide pour gap-tablet.",
  },
};

export default I18N;
